import { Reducer } from 'redux';
import { AtendimentosMensagensState, AtendimentosMensagensTypes } from './types';

const INITIAL_STATE: AtendimentosMensagensState = {
  data: {
    usuarios: [],
    mensagens: [],
  },
  error: false,
  loading: false,
};

const reducer: Reducer<AtendimentosMensagensState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AtendimentosMensagensTypes.SEND_MENSSAGE_REQUESTE:
      return {
        ...state,
        loading: true,
      };
    case AtendimentosMensagensTypes.SEND_MENSSAGE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: false,
      };
    case AtendimentosMensagensTypes.SEND_MENSSAGE_FAILURE:
      return {
        ...state,
        data: {
          usuarios: [],
          mensagens: [],
        },
        loading: false,
        error: true,
      };
    case AtendimentosMensagensTypes.CLEAR_MENSSAGE:
      return {
        ...state,
        data: {
          usuarios: [],
          mensagens: [],
        },
        loading: false,
        error: false,
      };

    default:
      return state;
  }
};

export default reducer;
